import script from "./VendorDetailDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./VendorDetailDialog.vue?vue&type=script&setup=true&lang=js"

import "./VendorDetailDialog.vue?vue&type=style&index=0&id=e95a5ec8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e95a5ec8"]])

export default __exports__